export default __webpack_public_path__ + "static/media/rounded-ticket.e8a81654.webp";